import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import PendingCard from "./PendingCard";
import { api } from "../lib/api";
import { PendingOut } from "../lib/schemas";

interface Props {
  groupId: number;
  currentTgId: number;
}

export default function PendingSection({ groupId, currentTgId }: Props) {
  const nav = useNavigate();

  const { data: pending } = useQuery({
    queryKey: ["pending", groupId],
    queryFn: () => api<PendingOut[]>("GET", `/pending?chat_id=${groupId}`),
    refetchInterval: 5_000,
    staleTime: 5_000,
  });

  const actionable = pending?.filter(
    (p) =>
      p.required_tg_ids.includes(currentTgId) &&
      (p.action_type === "receipt_settle" || p.sender_tg_id !== currentTgId),
  );

  if (!actionable || actionable.length === 0) return null;

  const count = actionable.length;
  const visible = actionable.slice(0, 3);

  return (
    <div className="mb-6">
      <div className="mb-3 flex items-end justify-between">
        <h2 className="font-sans text-xs font-medium text-muted">
          Needs your acceptance ({count})
        </h2>
        {count > 3 && (
          <button
            type="button"
            onClick={() => nav(`/inbox?chat=${groupId}`)}
            className="font-sans text-xs font-medium text-fg active:opacity-70 transition-opacity"
          >
            See all ({count}) →
          </button>
        )}
      </div>
      {visible.map((p) => (
        <PendingCard
          key={p.token}
          pending={p}
          currentTgId={currentTgId}
          showChatTitle={false}
        />
      ))}
    </div>
  );
}
